import { ITaskTypeChart, TaskTypeChart } from "../task/taskTypeChart";

export interface IAppReportTaskTypeTaskReference {
    name: string;
    taskTypeId: string;
    dateField: string;
    taskTypeChart: ITaskTypeChart;
    generalFilter: any;
}

export class AppReportTaskTypeTaskReference implements IAppReportTaskTypeTaskReference {
    name: string;
    taskTypeId: string;
    dateField: string;
    taskTypeChart: ITaskTypeChart;
    generalFilter: any;

    constructor();
    constructor(obj: IAppReportTaskTypeTaskReference);
    constructor(obj?: any) {
        this.name = obj?.name || "";
        this.taskTypeId = obj?.taskTypeId || "";
        this.dateField = obj?.dateField || "";
        this.taskTypeChart = new TaskTypeChart(obj?.taskTypeChart);
        this.generalFilter = obj?.generalFilter || null;
    }
}